import {Routes} from '@angular/router';
import {AuthGuard} from './service/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'main/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent),
    data: { title: 'Login Page' },
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () => import('./layout').then(m => m.DefaultLayoutComponent),
    data: {
      title: ''
    },
    children: [
      {
        path: 'main',
        loadChildren: () => import('./modules/home').then((m) => m.routes)
      },
      {
        path: 'kb',
        loadChildren: () => import('./modules/kb').then((m) => m.routes)
      },
      {
        path: 'conversation',
        loadChildren: () => import('./modules/conversation').then((m) => m.routes)
      },
      {
        path: 'content',
        loadChildren: () => import('./modules/content').then((m) => m.routes)
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules/admin').then((m) => m.routes)
      },
      {
        path: 'owner',
        loadChildren: () => import('./modules/owner').then((m) => m.routes)
      },
      {
        path: 'school',
        loadChildren: () => import('./modules/school').then((m) => m.routes)
      },
      {
        path: 'contacts',
        loadChildren: () => import('./modules/contact').then((m) => m.routes)
      },
      {
        path: 'store',
        loadChildren: () => import('./modules/store').then((m) => m.routes)
      },
      {
        path: 'resources',
        loadChildren: () => import('./modules/resources').then((m) => m.routes)
      },
      {
        path: 'exercises',
        loadChildren: () => import('./modules/exercises').then((m) => m.routes)
      },
      {
        // UCSF-3782: Experiments (assistant runs) under the Assistants tab.
        path: 'experiments',
        loadChildren: () => import('./modules/experiments').then((m) => m.routes)
      },
    ]
  },
  { path: '**', redirectTo: 'main/dashboard' }
];
